import React, { useState } from "react";
import { Modal, Button, Form, Col, Row, Spinner, Alert } from "react-bootstrap";
import {
  ENTER_VERIFICATION_CODE,
  ENTER_PASSWORD,
  PASSWORD_EIGHT_CHARACTERS,
  PASSWORD_DO_NOT_MATCH,
  RE_ENTER_PASSWORD,
  ENTER_NEW_PASSWORD,
  PASSWORD_UPDATED_SUCCESSFULLY,
  VERIFICATION_CODE_SPACES,
  PASSWORD_CONTAINS_SPACES,
  SET_NEW_PASSWORD,
  RESTORE_PASSWORD,
  ENTER_EMAIL_TO_RECEIVE_VERIFICATION_CODE,
  ENTER_VALID_EMAIL,
} from "../../configurations/MessageConstants";
import AuthHelper from "../../helpers/AuthHelper";
import { DANGER, EMPTY } from "../../configurations/Constants";

function ForgotPasswordPopup(props) {
  const [email, setEmail] = useState(EMPTY);
  const [verificationCode, setVerificationCode] = useState(EMPTY);
  const [btnSendClick, setBtnSendClick] = useState(false);
  const [btnResetPassClick, setBtnResetPassClick] = useState(false);
  const [AuthError, setAuthError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [password, setPassword] = useState(EMPTY);
  const [confirmPassword, setConfirmPassword] = useState(EMPTY);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState(EMPTY);
  const [verificationErrorMessage, setVerificationErrorMessage] =
    useState(EMPTY);
  const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] =
    useState(EMPTY);
  const [errorMessage, setErrorMessage] = useState(EMPTY);
  const [successMessage, setsuccessMessage] = useState(EMPTY);
  const [successInfo, setSuccessInfo] = useState(false);
  const [popUpHeader, setPopUpHeader] = useState(false);
  const [showpassword, setShowpassword] = useState(false);

  const resetState = () => {
    setEmail(EMPTY);
    setVerificationCode(EMPTY);
    setBtnSendClick(false);
    setBtnResetPassClick(false);
    setAuthError(false);
    setEmailError(false);
    setShowChangePassword(false);
    setVerificationCodeError(false);
    setPasswordError(false);
    setConfirmPasswordError(false);
    setPassword(EMPTY);
    setConfirmPassword(EMPTY);
    setPasswordErrorMessage(EMPTY);
    setVerificationErrorMessage(EMPTY);
    setConfirmPasswordErrorMessage(EMPTY);
    setErrorMessage(EMPTY);
    setsuccessMessage(EMPTY);
    setSuccessInfo(false);
    setPopUpHeader(false);
    setShowpassword(false);
  };
  const checkVerificationCode = (e) => {
    e.persist();
    setEmail(e.target.value);
    setEmailError(false);
    if (e.target.value === EMPTY) {
      setEmailError(true);
    }
  };
  const onValueChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "verificationCode") {
      setVerificationCode(value);
      setVerificationCodeError(false);
      if (value === EMPTY) {
        setVerificationCodeError(true);
        setVerificationErrorMessage(ENTER_VERIFICATION_CODE);
      }
      if (value.includes(" ")) {
        setVerificationCodeError(true);
        setVerificationErrorMessage(VERIFICATION_CODE_SPACES);
      }
    }
    if (name === "password") {
      setPassword(value);
      if (value === EMPTY) {
        setPasswordError(true);
        setPasswordErrorMessage(ENTER_PASSWORD);
      } else if (value.length < 8) {
        setPasswordError(true);
        setPasswordErrorMessage(PASSWORD_EIGHT_CHARACTERS);
      } else {
        setPasswordError(false);
        setPasswordErrorMessage(EMPTY);
      }
      if (value.includes(" ")) {
        setPasswordError(true);
        setPasswordErrorMessage(PASSWORD_CONTAINS_SPACES);
      }
      if (value !== confirmPassword) {
        if (confirmPassword.length === 0) {
          setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
        } else setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
        setConfirmPasswordError(true);
      } else {
        setPasswordError(false);
        setConfirmPasswordError(false);
        setPasswordErrorMessage(EMPTY);
        setConfirmPasswordErrorMessage(EMPTY);
      }
    }
    if (name === "confirmPassword") {
      setConfirmPassword(value);
      if (value !== password) {
        setConfirmPasswordErrorMessage(
          value.length > 0 ? PASSWORD_DO_NOT_MATCH : RE_ENTER_PASSWORD
        );
        if (value.includes(" "))
          setConfirmPasswordErrorMessage(PASSWORD_CONTAINS_SPACES);
        setConfirmPasswordError(true);
      } else {
        setConfirmPasswordError(false);
        setConfirmPasswordErrorMessage(EMPTY);
      }
    }
  };

  const sendEmail = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setEmailError(false);
    if (!email) {
      setEmailError(true);
      setErrorMessage(ENTER_VALID_EMAIL);
      return;
    }
    setBtnSendClick(true);
    try {
      await AuthHelper.ForgotPassword(email.toLowerCase().trim());
      setEmailError(false);
      setErrorMessage(EMPTY);
      setBtnSendClick(false);
      setShowChangePassword(true);
      setPopUpHeader(true);
    } catch (error) {
      setBtnSendClick(false);
      setEmailError(true);
      setErrorMessage(error.response.data.message);
    }
  };

  const resetPassword = async (event) => {
    setBtnResetPassClick(true);
    event.preventDefault();
    event.stopPropagation();
    setPasswordError(false);
    setConfirmPasswordError(false);
    setVerificationCodeError(false);

    if (verificationCode === EMPTY) {
      setVerificationCodeError(true);
      setVerificationErrorMessage(ENTER_VERIFICATION_CODE);
      setBtnResetPassClick(false);
    }
    if (password === EMPTY) {
      setPasswordError(true);
      setPasswordErrorMessage(ENTER_NEW_PASSWORD);
      setBtnResetPassClick(false);
    }
    if (confirmPassword === EMPTY) {
      setConfirmPasswordError(true);
      setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
      setBtnResetPassClick(false);
    }
    if (password !== EMPTY) {
      if (password.length < 8) {
        setPasswordError(true);
        setPasswordErrorMessage(PASSWORD_EIGHT_CHARACTERS);
        setBtnResetPassClick(false);
      }
      if (confirmPassword === EMPTY) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(RE_ENTER_PASSWORD);
        setBtnResetPassClick(false);
      } else if (confirmPassword.length < 8 || password !== confirmPassword) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
        setBtnResetPassClick(false);
        return false;
      }
    }

    if (
      verificationCode === EMPTY ||
      password === EMPTY ||
      confirmPassword === EMPTY
    ) {
      if (password !== confirmPassword) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage(PASSWORD_DO_NOT_MATCH);
        setBtnResetPassClick(false);
      }
      return false;
    }
    const payload = {
      confirmation_code: verificationCode,
      username: email.toLowerCase().trim(),
      password: password,
    };
    try {
      await AuthHelper.ConfirmPassword(payload);
      setSuccessInfo(true);
      setAuthError(false);
      setsuccessMessage(PASSWORD_UPDATED_SUCCESSFULLY);

      setTimeout(function () {
        resetState();
        props.closeModal();
      }, 3000);
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setAuthError(true);
      setBtnResetPassClick(false);
    }
  };

  const toggleShowPassword = () => {
    const showPassword = !showpassword;
    setShowpassword(showPassword);
  };

  let closeModal = () => {};
  return (
    <Modal
      show={props.showForgotPasswordPopup}
      onHide={closeModal}
      className="confirm-modal"
    >
      <Modal.Header>
        <h3>{popUpHeader === false ? RESTORE_PASSWORD : SET_NEW_PASSWORD}</h3>
      </Modal.Header>
      <Modal.Body>
        {AuthError && (
          <Alert
            variant={DANGER}
            onClose={() => setAuthError(false)}
            dismissible
          >
            {errorMessage}
          </Alert>
        )}
        {successInfo && (
          <Alert
            variant="success"
            onClose={() => setSuccessInfo(false)}
            dismissible
          >
            {successMessage}
          </Alert>
        )}
        {showChangePassword === false ? (
          <div>
            <p color="muted">{ENTER_EMAIL_TO_RECEIVE_VERIFICATION_CODE}</p>
            <Form noValidate>
              <div>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      name="Email"
                      onChange={(e) => {
                        checkVerificationCode(e);
                      }}
                      value={email || EMPTY}
                      className={
                        emailError
                          ? "is-invalid invalidcontrol"
                          : email !== EMPTY
                          ? "is-valid"
                          : EMPTY
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errorMessage}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </div>
              <Button
                disabled={btnSendClick}
                type="submit"
                onClick={(e) => sendEmail(e)}
              >
                {btnSendClick ? (
                  <div>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    <span>Sending</span>
                  </div>
                ) : (
                  "Send"
                )}
              </Button>{" "}
              <Button
                type="button"
                onClick={(e) => {
                  resetState();
                  props.closeModal();
                }}
              >
                Close
              </Button>
            </Form>
          </div>
        ) : (
          <Form noValidate>
            <div>
              <Row>
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="validationVerificationCode"
                >
                  <Form.Label>Verification Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="verificationCode"
                    onChange={(e) => {
                      onValueChange(e);
                    }}
                    value={verificationCode || EMPTY}
                    className={
                      verificationCodeError
                        ? "is-invalid invalidcontrol"
                        : verificationCode !== EMPTY
                        ? "is-valid"
                        : EMPTY
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {verificationErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} md="12" controlId="validationPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type={showpassword ? "text" : "password"}
                    name="password"
                    minLength="8"
                    onChange={(e) => {
                      onValueChange(e);
                    }}
                    value={password || EMPTY}
                    className={
                      passwordError
                        ? "is-invalid invalidcontrol"
                        : password !== EMPTY
                        ? password.length < 8
                          ? "is-invalid invalidcontrol"
                          : "is-valid"
                        : EMPTY
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {passwordErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} md="12" controlId="validationConfPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type={showpassword ? "text" : "password"}
                    name="confirmPassword"
                    onChange={(e) => {
                      onValueChange(e);
                    }}
                    value={confirmPassword || EMPTY}
                    className={
                      confirmPasswordError
                        ? "is-invalid invalidcontrol"
                        : confirmPassword !== EMPTY
                        ? "is-valid"
                        : confirmPassword !== password
                        ? "is-invalid invalidcontrol"
                        : EMPTY
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {confirmPasswordErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} md="12">
                  <Form.Check
                    id="showPasswordForgotId"
                    type="checkbox"
                    label="Show Password"
                    onChange={() => {
                      toggleShowPassword();
                    }}
                  />
                </Form.Group>
              </Row>
            </div>
            <Button
              disabled={
                btnResetPassClick ||
                verificationCodeError ||
                passwordError ||
                confirmPasswordError
              }
              type="submit"
              onClick={(e) => resetPassword(e)}
            >
              {btnResetPassClick ? (
                <div>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  <span>Changing</span>
                </div>
              ) : (
                "Change Password"
              )}
            </Button>{" "}
            <Button
              type="button"
              onClick={(e) => {
                resetState();
                props.closeModal();
              }}
            >
              Close
            </Button>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ForgotPasswordPopup;
